module.exports = __webpack_public_path__ + "media/images/flags/16/Brazil-d8caca612e0a57cfcc4ab716b19cadbc.png";